// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s-leasing-car__tagged[data-v-344f807e] {
  background-color: var(--344f807e-highlightBgColor);
  color: white;
}
.s-contact-note__body[data-v-344f807e] {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/js/vue/apps/LeasingCarSaver.vue","webpack://./LeasingCarSaver.vue"],"names":[],"mappings":"AACA;EACE,kDAAA;EACA,YAAA;ACAF;ADEA;EACE,WAAA;ACCF","sourcesContent":["\r\n.s-leasing-car__tagged {\r\n  background-color: v-bind(highlightBgColor);\r\n  color: white;\r\n}\r\n.s-contact-note__body {\r\n  width: 100%;\r\n}\r\n",".s-leasing-car__tagged {\n  background-color: v-bind(highlightBgColor);\n  color: white;\n}\n\n.s-contact-note__body {\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
